var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57388 18C8.43643 18 8.28179 17.9279 8.17869 17.8196L0.171822 9.41483C0.0687284 9.30661 0 9.14429 0 9C0 8.85571 0.0687284 8.69339 0.171822 8.58517L8.17869 0.180361C8.28179 0.0721443 8.43643 0 8.57388 0C8.71134 0 8.86598 0.0721443 8.96907 0.180361L9.82818 1.08216C9.93127 1.19038 10 1.33467 10 1.49699C10 1.64128 9.93127 1.80361 9.82818 1.91182L3.0756 9L9.82818 16.0882C9.93127 16.1964 10 16.3587 10 16.503C10 16.6473 9.93127 16.8096 9.82818 16.9178L8.96907 17.8196C8.86598 17.9279 8.71134 18 8.57388 18Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.6a0af66f615033267978c2d5ed44a068.svg";
export { ForwardRef as ReactComponent };